export enum AnnotationType {
  pdf = 'PDF'
}
